(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gl-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gl-video')) customElements.define('gl-video', class extends HTMLElement {
 connectedCallback() {
  if (this.observer) return;
  const video = this.querySelector('video');
  if (!video) return;
  this.video = video;
  if (this.getAttribute('aria-label')) video.setAttribute('aria-label', this.getAttribute('aria-label'));
  this.onVisibility = () => { if (document.hidden) video.pause(); };
  document.addEventListener('visibilitychange', this.onVisibility);
  this.observer = new IntersectionObserver(entries => {
   for (const entry of entries) {
    if (!entry.isIntersecting || entry.intersectionRatio < 0.15) { video.pause(); continue; }
    if (this.hasAttribute('data-autoplay') && !this.started && !document.hidden && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
     this.started = true;
     video.muted = true;
     video.play().catch(() => { this.started = false; });
    }
   }
  }, {threshold: [0, 0.15]});
  this.observer.observe(this);
 }
 disconnectedCallback() {
  this.video?.pause();
  this.observer?.disconnect();
  this.observer = null;
  document.removeEventListener('visibilitychange', this.onVisibility);
 }
});
  } catch(e) { console.error(e); }
})();

})();
